import 'jquery';
import Blazy from 'blazy';
import 'slick-carousel';

import './util/home';
import './util/slider';
import './util/clicker';
import './util/popup';
import './util/titles';

let $body = $('body'),
    bLazy = new Blazy();

$(() => {
  // Lazy Load Images
  bLazy.load();

  // Loader
  setTimeout(function() {
    bLazy.revalidate();
    window.scrollTo(0, 0);
    $body.addClass('loaded');
  }, 500);

  $(window).on('resize',function() {
    bLazy.revalidate();
  });

  // Menu Toggle
  const $menuToggle = $('.js-menu-toggle'),
        $menuDrawer = $('#main-menu');

  $menuToggle.on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $menuDrawer.toggleClass('active');
    $body.toggleClass('menu-open');

    let $listItems = $('#main-menu').find('li.menu-item');

    if($('body').hasClass('menu-open')) {
      // pop the menu items
      let delay = 250;
      setTimeout(function() {
        $($listItems).each(function() {
          let $item = $(this);
          setTimeout(function() {
            $item.addClass('visible');
          }, delay+=150);
        });
      }, 50);

      // close menu on anchor click
      $('ul#menu-main').on('click', 'a', function() {
        $menuToggle.removeClass('active');
        $menuDrawer.removeClass('active');
        $body.removeClass('menu-open');
        $($listItems).each(function() {
          let $item = $(this);
          $item.removeClass('visible');
        });
      });

    } else {
      // remove visibility from menu items
      $($listItems).each(function() {
        let $item = $(this);
        $item.removeClass('visible');
      });
    }
  });

  // Smooth Scroll to Anchor on Click
  document.querySelectorAll('a:not(.js-menu-toggle)[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth',
      });
    });
  });

  $('a.js-trigger-details').on('click', (e) => {
    e.preventDefault();
    $(e.currentTarget).parents('article').toggleClass('active');
    setTimeout(function() {
      bLazy.revalidate();
      bLazy.revalidate();
    }, 250);
  });
});
